<script lang="ts" setup>
import { VContainer } from 'vuetify/components';
</script>

<template>
    <v-container> </v-container>
</template>
